module.exports = __webpack_public_path__ + "static/media/de_dust2.09025ff1.jpg";